import { render } from "./addBorough.vue?vue&type=template&id=f3b8854a&scoped=true"
import script from "./addBorough.vue?vue&type=script&lang=js"
export * from "./addBorough.vue?vue&type=script&lang=js"

import "./addBorough.vue?vue&type=style&index=0&id=f3b8854a&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b8854a"]])

export default __exports__